import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import "hammerjs";

if (environment.production) {
  enableProdMode();
}

// Disable console.log only in QA & PROD
if (environment.production || environment.version.startsWith("QA Build")) {
  console.log = function () {};
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((ref) => {
    if (window["ngRef"]) {
      window["ngRef"].destroy();
    }
    window["ngRef"] = ref;
  })
  .catch((err) => console.error(err));